import SkeletonLoader from "../SkeletonLoader"

const TableSkeleton: React.FC = () => {
  const rowHeight = 45
  const rowClassName = "w-full flex-1 mt-2"
  return (
    <div className="flex flex-col w-full">
      <div
        className={`flex flex-col rounded-lg border-solid border-[1px] border-gray-200 p-4`}
      >
        <div className="w-full">
          <SkeletonLoader height={2 * rowHeight} />
        </div>
        <div className="w-full flex flex-col">
          {[...Array(10)].map((_, idx) => (
            <div className={rowClassName} key={`skeleton-row-${idx}`}>
              <SkeletonLoader height={rowHeight} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TableSkeleton
